import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ReasonActions, ReasonActionTypes } from '../_actions/reason.actions';
import { QueryParamsModel } from '../../_base/crud';
import { Reason } from '../_models/reason.model';

// tslint:disable-next-line:no-empty-interface
export interface ReasonsState extends EntityState<Reason> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedReasonId: number;
  lastCreatedReason: Reason;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Reason> = createEntityAdapter<Reason>();

export const initialReasonsState: ReasonsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedReasonId: undefined,
  lastCreatedReason: undefined,
  showInitWaitingMessage: true,
});

export function reasonsReducer(state = initialReasonsState, action: ReasonActions): ReasonsState {
  switch (action.type) {
    case ReasonActionTypes.ReasonsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedReasonId: undefined,
      };
    case ReasonActionTypes.ReasonsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case ReasonActionTypes.ReasonDeleted:
      return adapter.removeOne(action.payload.id, state);
    case ReasonActionTypes.ReasonsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case ReasonActionTypes.ReasonsPageLoaded: {
      return adapter.addMany(action.payload.reasons, {
        ...initialReasonsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case ReasonActionTypes.ThrowReasonError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case ReasonActionTypes.FireReasonSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getReasonState = createFeatureSelector<ReasonsState>('reasons');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
